/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import React, { memo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import './VideoBackground.css';
import Header from '../components/header/Header.tsx';
import bgVideo from '../../public/videos/bg-video.mp4';
import Footer from '../components/footer/Footer.tsx';
import { useTranslation } from '../components/common/Translation/translationProvider.tsx';
import { useAppSelector } from '../redux/hooks.tsx';
import { isLoggedInSelector } from '../redux/loginSlice.tsx';
import InfoIcon from '@mui/icons-material/Info';
import placeholderImage from '../../public/images/backgroundImagePWC.png'
import AppWrapper from '../utils/appwrapper.tsx';
const VideoLayout = memo(() => {

  const { t } = useTranslation();
  const { appMaintenance, maintenanceMessage, portalName, portalSecondaryHeader } = useAppSelector(isLoggedInSelector);

  return (
    <div className="layout-wrapper">
      <AppWrapper>
      <Header />
      <div className="video-background-container">
        <div className='video-container'>
       
          <video autoPlay muted loop disablePictureInPicture preload='metadata' 
               controlsList="nodownload noremoteplayback">
            <source src={bgVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className='text-container'>
          {appMaintenance ? <div className="maintenanceBanner">
            <section className="infoMen"> <InfoIcon className="infoicon" /> <div dangerouslySetInnerHTML={{ __html: maintenanceMessage }}></div> </section>
          </div> : <></>}
          <div className="HeadingText">{t(portalName)}
            {portalSecondaryHeader && (<p className="sub-header" dangerouslySetInnerHTML={{ __html: portalSecondaryHeader }} />)}
          </div>

          <div className="content">
            <Outlet />
          </div>
        </div>
      </div>
      
      
      
      <Footer />
      </AppWrapper>
    </div>
  );
});

export default VideoLayout;
